import React, {useState, useEffect, useCallback} from 'react';
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
} from 'reactstrap';
import {connect} from 'react-redux';
import {createCustomer} from '../../store/customer/actions';
import {Link, useNavigate} from 'react-router-dom';
import {SweetAlert} from '../../components/Common/SweetAlert';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import ListCountries from '../../components/Lists/ListCountries';
import {apiError} from '../../store/auth/login/actions';
import authHeader from '../../helpers/jwt-token-access/auth-token-header';
import axios from 'axios';
import ModalExistingCustomers from
  '../../components/Modals/modal-existingcustomers';
import _debounce from 'lodash.debounce';
import FormCheckbox from '../../components/Common/FormCheckbox';
import FormRadio from '../../components/Common/FormRadio';
import FormField from '../../components/Common/FormField';
import {FormProvider, useForm} from 'react-hook-form';
import FormCheckboxGroup from '../../components/Common/FormCheckboxGroup';

const CustomerAdd = (props) => {
  const [errorMsg, setErrorMsg] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [existingCustomers, setExistingCustomers] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const form = useForm({
    defaultValues: {
      name: '',
      contact_name: '',
      additional_address: '',
      street: '',
      street_no: '',
      zip_code: '',
      city: '',
      country: '',
      phone: '',
      email: '',
      www: '',
      dealer_id: '',
      type_of_business: [],
      type_of_business_other: '',
      no_of_staff: '',
      printed_media: [],
      printed_media_other: '',
      projected_print_amount: '',
      environmental_conditions: [],
      room_temperatur: '',
      room_humidity: '',
      operating_system: [],
      operating_system_other: '',
      pre_treatment: [],
      pre_treatment_other: '',
      pre_treatment_info: '',
      heatpress_brand: '',
      dryer_brand: '',
      graphics_software: [],
      graphics_software_other: '',
      white_shaking_tools: [],
    },
  });
  const {
    watch,
    handleSubmit,
  } = form;

  const type_of_business = watch('type_of_business');

  useEffect(() => {
    setIsLoading(false);
    if (props.data && props.data.success) {
      setSuccessMsg(true);
    } else if (props.data && props.data.error) {
      setErrorMsg(props.data.error);
    }
  }, [props.data]);

  function handleChangeName(name) {
    debounce(name);
  }

  const debounce = useCallback(
      _debounce((name) => {
        const url = process.env.REACT_APP_APIURL + 'customer/checkduplicate';
        const authToken = authHeader();

        const formData = new FormData();
        formData.append('name', name);

        return axios.post(
            url, formData, {headers: authToken},
        ).then(() => {
        // setCustomerStatus(response.status === 201);
          setExistingCustomers(null);
        }).catch((error) => {
        // setCustomerStatus(true);
          setExistingCustomers(error.response.data.customers);
        });
      }, 2000),
      [],
  );


  function handleValidSubmit(values) {
    setIsLoading(true);

    const customer = {
      name: values.name,
      contact_name: values.contact_name,
      additional_address: values.additional_address,
      street: values.street,
      street_no: values.street_no,
      zip_code: values.zip_code,
      city: values.city,
      country: values.country,
      phone: values.phone,
      email: values.email,
      www: values.www,
      // logo: values.logo,
      dealer_id: values.dealer_id,
      business_information: {
        type_of_business: [
          ...values.type_of_business,
          values.type_of_business_other,
        ],
        dtf_options: values.dtf_options ? values.dtf_options : [],
        no_of_staff: values.no_of_staff,
        printed_media: [...values.printed_media, values.printed_media_other],
        projected_print_amount: values.projected_print_amount,
        environmental_conditions: values.environmental_conditions,
        environmental_conditions_temperature: values.room_temperatur,
        environmental_conditions_humidity: values.room_humidity,
        operating_system: [
          ...values.operating_system,
          values.operating_system_other,
        ],
        pre_treatment: [...values.pre_treatment, values.pre_treatment_other],
        pre_treatment_info: values.pre_treatment_info,
        heatpress_brand: values.heatpress_brand,
        dryer_brand: values.dryer_brand,
        graphics_software: [
          ...values.graphics_software,
          values.graphics_software_other,
        ],
        white_shaking_tools: values.white_shaking_tools,
      },
    };
    props.createCustomer(customer);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>

          <Breadcrumbs
            parent="/customers"
            title="Customers"
            breadcrumbItem="Add Customer"
          />

          <Row>
            <Col xs="12">
              <FormProvider {...form}>
                <form
                  className="form-horizontal"
                  onSubmit={handleSubmit(handleValidSubmit)}
                >
                  {errorMsg ?
                    <SweetAlert
                      title="Error!"
                      danger
                      showConfirm={true}
                      showCancel={false}
                      confirmBtnBsStyle="danger"
                      closeOnConfirm={true}
                      onConfirm={() => {
                        setErrorMsg(false);
                      }}
                    >
                      {errorMsg}
                    </SweetAlert> : ''
                  }
                  {successMsg ? <SweetAlert
                    title="Good job!"
                    success
                    showConfirm={true}
                    showCancel={false}
                    confirmBtnBsStyle="yellow"
                    onConfirm={() => {
                      navigate('/customers');
                    }}
                  >
                    The customer has been added!
                  </SweetAlert> : null}
                  <ModalExistingCustomers customers={existingCustomers}/>
                  <Card>
                    <CardBody>
                      <CardTitle>Customer Informations</CardTitle>
                      <CardSubtitle className="mb-3">
                        Fill all information below
                      </CardSubtitle>
                      <Row>
                        <Col md="6">
                          <FormField
                            name="name"
                            className="form-control"
                            placeholder="Company name *"
                            label="Company"
                            type="text"
                            validate={
                              {
                                required: {value: true},
                              }
                            }
                            onChange={(e) => handleChangeName(e.target.value)}
                            errorMessage="Please provide a valid name."
                          />
                        </Col>
                        <Col md="4">
                          <FormField
                            name="contact_name"
                            className="form-control"
                            placeholder="Contact name *"
                            label="Contact"
                            type="text"
                            validate={{required: {value: true}}}
                            errorMessage="Please provide a contact name."
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="3">
                          <FormField
                            name="additional_address"
                            className="form-control"
                            placeholder="Additional Address (optional)"
                            label="Additional Address"
                            type="text"
                            validate={{required: {value: false}}}
                            errorMessage="Please provide a valid additional
                          address."
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="3">
                          <FormField
                            name="street"
                            className="form-control"
                            placeholder="Street *"
                            label="Street"
                            type="text"
                            validate={{required: {value: true}}}
                            errorMessage="Please provide a valid street."
                          />
                        </Col>
                        <Col md="2">
                          <FormField
                            name="street_no"
                            className="form-control"
                            placeholder="Street No *"
                            label="Street No"
                            type="text"
                            validate={{required: {value: true}}}
                            errorMessage="Please provide a valid street no."
                          />
                        </Col>
                        <Col md="2">
                          <FormField
                            name="zip_code"
                            className="form-control"
                            placeholder="Zip Code *"
                            label="Zip Code"
                            type="text"
                            validate={{required: {value: true}}}
                            errorMessage="Please provide a valid zip code."
                          />
                        </Col>
                        <Col md="3">
                          <FormField
                            name="city"
                            className="form-control"
                            placeholder="City *"
                            label="City"
                            type="text"
                            validate={{required: {value: true}}}
                            errorMessage="Please provide a valid city."
                          />
                        </Col>
                        <Col md="3">
                          <div className="form-group">
                            <Label htmlFor="country"
                            >Country</Label>
                            <ListCountries required={true}/>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4">
                          <FormField
                            name="phone"
                            className="form-control"
                            placeholder="Phone *"
                            label="Phone"
                            type="text"
                            validate={{required: {value: true}}}
                            errorMessage="Please provide a valid phone number."
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4">
                          <FormField
                            name="email"
                            className="form-control"
                            placeholder="Email Address*"
                            label="Email"
                            type="text"
                            validate={{required: {value: true}}}
                            errorMessage="Please provide a valid email address."
                          />
                        </Col>
                        <Col md="4">
                          <FormField
                            name="www"
                            className="form-control"
                            placeholder="Web Address *"
                            label="Web Address"
                            type="text"
                            validate={{required: {value: true}}}
                            errorMessage="Please provide a web address."
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <CardTitle>Business Information</CardTitle>
                      <CardSubtitle className="mb-3">
                        Fill all information below
                      </CardSubtitle>
                      <FormGroup className="mb-4" row>
                        <Label
                          htmlFor="type_of_business"
                          md="2"
                        >
                          Business Type
                        </Label>
                        <Col md="5">
                          <Row>
                            <Col md="6">
                              <FormCheckbox name="type_of_business" label="Embroidery"
                                value="Embroidery"/>
                              <FormCheckbox name="type_of_business" label="Entertainment"
                                value="Entertainment"/>
                              <FormCheckbox name="type_of_business" label="DTF"
                                value="DTF"/>
                              <FormCheckbox name="type_of_business" label="Fashion"
                                value="Fashion"/>
                              <FormCheckbox name="type_of_business" label="Heat Transfer"
                                value="Heat Transfer"/>
                            </Col>
                            <Col md="6">
                              <FormCheckbox name="type_of_business" label="Internet"
                                value="Internet"/>
                              <FormCheckbox name="type_of_business" label="Promotion"
                                value="Promotion"/>
                              <FormCheckbox name="type_of_business" label="Screen Printing"
                                value="Screen Printing"/>
                              <FormCheckbox name="type_of_business" label="Signage"
                                value="Signage"/>
                              <FormCheckbox name="type_of_business" label="Retailshop"
                                value="Retailshop"/>
                            </Col>
                          </Row>
                          <FormField
                            className="w-50"
                            type="text"
                            name="type_of_business_other"
                            label="Other"/>
                        </Col>
                      </FormGroup>
                      {type_of_business.includes('DTF') &&
                          <FormGroup className="mb-4" row>
                            <Label
                              htmlFor="dtf_options"
                              md="2"
                            >
                              DTF Options
                            </Label>
                            <Col md="6">
                              <FormCheckboxGroup
                                name="dtf_options"
                                options={[
                                  {label: 'Apply Transfers (Garment Decoration)', value: 'Apply Transfers'},
                                  {label: 'Sell Transfers (Resale)', value: 'Sell Transfers'},
                                ]}
                                validate={{required: {value: true}}}
                                errorMessage="Please select at least one option."
                              />
                            </Col>
                          </FormGroup>
                      }
                      <FormGroup className="mb-4" row>
                        <Label
                          htmlFor="no_of_staff"
                          md="2"
                        >
                          No. of Staff
                        </Label>
                        <Col md="10">
                          <FormRadio name="no_of_staff" label="1" value="1"/>
                          <FormRadio name="no_of_staff" label="3-5" value="3-5"/>
                          <FormRadio name="no_of_staff" label="6-10" value="6-10"/>
                          <FormRadio name="no_of_staff" label="10+" value="10+"/>
                        </Col>
                      </FormGroup>
                      <FormGroup className="mb-4" row>
                        <Label
                          htmlFor="printed_media"
                          md="2"
                          className="col-form-label"
                        >
                          Media to be printed with
                        </Label>
                        <Col md="10">
                          <FormCheckbox name="printed_media" label="Caps" value="Caps"/>
                          <FormCheckbox name="printed_media" label="Shoes" value="Shoes"/>
                          <FormCheckbox
                            name="printed_media"
                            label="T-Shirts"
                            value="T-Shirts"
                          />
                          <FormCheckbox name="printed_media" label="Sweatshirts"
                            value="Sweatshirts"/>
                          <FormCheckbox
                            name="printed_media"
                            label="Hoodies"
                            value="Hoodies"
                          />
                          <FormField
                            className="w-25"
                            type="text"
                            name="printed_media_other"
                            label="Other"/>
                        </Col>
                      </FormGroup>
                      <FormGroup className="mb-4" row>
                        <Label htmlFor="projected_print_amount" md="2"
                        >
                          Print amount per month
                        </Label>
                        <Col md="10">
                          <FormRadio name="projected_print_amount" label="<50" value="<50"/>
                          <FormRadio name="projected_print_amount" label="50-100" value="50-100"/>
                          <FormRadio name="projected_print_amount" label="101-500" value="101-500"/>
                          <FormRadio name="projected_print_amount" label="501-1999" value="501-1999"/>
                          <FormRadio name="projected_print_amount" label=">2000" value=">2000"/>
                        </Col>
                      </FormGroup>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <CardTitle>Environmental Conditions</CardTitle>
                      <FormGroup className="mb-4">
                        <FormCheckbox name="environmental_conditions" label="Air Conditionning"
                          value="Air Conditionning"/>
                        <FormCheckbox
                          name="environmental_conditions"
                          label="Humidifier"
                          value="Humidifier"
                        />
                      </FormGroup>
                      <Row>
                        <Col md={3}>
                          <FormField type="text" name="room_temperatur"
                            label="Temperature (in °C)"/>
                        </Col>
                        <Col md={3}>
                          <FormField type="text" name="room_humidity"
                            label="Room Humidity (in %)"/>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <CardTitle>Operating System</CardTitle>
                      <FormGroup className="mb-4" row>
                        <Col md="10">
                          <Label
                            htmlFor="printed_media"
                            md="2"
                            className="col-form-label"
                          >
                            Windows
                          </Label>
                          <FormCheckbox
                            name="operating_system"
                            label="Windows 7"
                            value="Windows 7"
                          />
                          <FormCheckbox
                            name="operating_system"
                            label="Windows 8"
                            value="Windows 8"
                          />
                          <FormCheckbox
                            name="operating_system"
                            label="Windows 10"
                            value="Windows 10"
                          />
                          <FormCheckbox
                            name="operating_system"
                            label="Windows 11"
                            value="Windows 11"
                          />
                          <FormCheckbox
                            name="operating_system"
                            label="Other"
                            value="Other"
                          />
                          <Label
                            htmlFor="printed_media"
                            md="2"
                            className="col-form-label"
                          >
                            Macintosh
                          </Label>
                          <FormCheckbox name="operating_system" label="10.10 Yosemite"
                            value="10.10 Yosemite"/>
                          <FormCheckbox name="operating_system" label="10.11 El Capitan"
                            value="10.11 El Capitan"/>
                          <FormCheckbox name="operating_system" label="10.12 Sierra"
                            value="10.12 Sierra"/>
                          <FormCheckbox name="operating_system" label="10.13 High Sierra"
                            value="10.13 High Sierra"/>
                          <FormCheckbox name="operating_system" label="10.14 Mojave"
                            value="10.14 Mojave"/>
                          <FormCheckbox name="operating_system" label="10.15 Catalina"
                            value="10.15 Catalina"/>
                          <FormCheckbox name="operating_system" label="11 Big Sur"
                            value="11 Big Sur"/>
                          <FormCheckbox name="operating_system" label="12 Monterey"
                            value="12 Monterey"/>
                          <FormCheckbox name="operating_system" label="13 Ventura"
                            value="13 Ventura"/>
                        </Col>
                      </FormGroup>
                      <FormField
                        className="w-25"
                        type="text"
                        name="operating_system_other"
                        label="Other"
                      />
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <CardTitle>Pre-Treatment Application</CardTitle>
                      <FormCheckbox name="pre_treatment" label="PT-Line" value="PT-Line"/>
                      <FormCheckbox name="pre_treatment" label="PTM5" value="PTM5"/>
                      <FormCheckbox name="pre_treatment" label="PTM4" value="PTM4"/>
                      <FormCheckbox name="pre_treatment" label="PTM3" value="PTM3"/>
                      <FormCheckbox name="pre_treatment" label="Manual" value="Manual"/>
                      <FormField
                        className="w-25"
                        type="text"
                        name="pre_treatment_other"
                        label="Other"
                      />
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <CardTitle>Heat Press Info</CardTitle>
                      <FormField type="text" name="heatpress_brand" label="Brand"/>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <CardTitle>Conveyor Dryer Info</CardTitle>
                      <FormField type="text" name="dryer_brand" label="Brand"/>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <CardTitle>Software related</CardTitle>
                      <FormGroup className="mb-4" row>
                        <Label
                          htmlFor="graphics_software"
                          md="2"
                          className="col-form-label"
                        >
                          Which Graphics Software is used by customer
                        </Label>
                        <Col md="10">
                          <FormCheckbox name="graphics_software" label="Cadlink"
                            value="Cadlink"/>
                          <FormCheckbox name="graphics_software" label="Corel Draw"
                            value="Corel Draw"/>
                          <FormCheckbox name="graphics_software" label="GraphicsLab"
                            value="GraphicsLab"/>
                          <FormCheckbox name="graphics_software" label="Illustrator"
                            value="Illustrator"/>
                          <FormCheckbox name="graphics_software" label="Photoshop"
                            value="Photoshop"/>
                          <FormCheckbox name="graphics_software" label="ColorGATE"
                            value="ColorGATE"/>
                          <FormCheckbox name="graphics_software" label="Ergosoft"
                            value="Ergosoft"/>
                          <FormCheckbox name="graphics_software" label="Versaworks"
                            value="Versaworks"/>
                          <FormCheckbox name="graphics_software" label="Cadlink/Fiery"
                            value="Cadlink/Fiery"/>
                          <FormCheckbox name="graphics_software" label="Caldera"
                            value="Caldera"/>
                          <FormCheckbox name="graphics_software" label="Onyx"
                            value="Onyx"/>
                          <FormCheckbox name="graphics_software" label="SAI"
                            value="SAI"/>
                          <FormField
                            className="w-25"
                            type="text"
                            name="graphics_software_other"
                            label="Other"/>
                        </Col>
                      </FormGroup>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <CardTitle>GTXpro Bulk Customer only</CardTitle>
                      <FormGroup className="mb-4" row>
                        <Col md="10">
                          <FormCheckbox name="white_shaking_tools" label="White Shaking Tools"
                            value="true"/>
                        </Col>
                      </FormGroup>
                    </CardBody>
                  </Card>

                  <Row className="my-4">
                    <Col sm="6">
                      <Link to="/customers"
                        className="btn d-none d-sm-inline-block btn-link">
                        <i className="mdi mdi-arrow-left mr-1"/>
                        Back to Customers Overview
                      </Link>
                    </Col>
                    <Col sm="6">
                      <div className="text-sm-right">
                        {isLoading ?
                          <Button
                            className="btn btn-yellow"
                            type="submit"
                            disabled={true}
                          >
                            <i
                              className="bx bx-loader bx-spin font-size-16
                            align-middle mr-2"/>
                            Submit Customer
                          </Button> :
                          <Button className="btn btn-yellow" type="submit">
                            <i className="mdi mdi-plus-thick mr-1"/>
                            Submit Customer
                          </Button>
                        }
                      </div>
                    </Col>
                  </Row>
                </form>
              </FormProvider>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};


const mapStatetoProps = (state) => {
  const {data} = state.Customer;
  state.Customer = {};
  return {data};
};

export default connect(
    mapStatetoProps, {createCustomer, apiError},
)(CustomerAdd);
